import { render, staticRenderFns } from "./TreatyStmtAuditList.vue?vue&type=template&id=113b64ab&"
import script from "./TreatyStmtAuditList.vue?vue&type=script&lang=js&"
export * from "./TreatyStmtAuditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports